'use strict';

var toastr = require('toastr');
var SystemStatusReoptimizationController = function SystemStatusReoptimizationController($scope, restangular, dataRetrieverService, dataRetrieverConstantsService, reoptimizationService, systemStatusCommonRendererFactory, SearchCriteriaRule, configurationService) {
  function getSearchCriteria() {
    var ruleParams = {
      category: 'System Status',
      metaCategory: 'System Status',
      shortCriterionName: 'System Status',
      criterion: 'reoptimizationQueue',
      operator: '=',
      field: 'events[].carrier',
      searchContext: '',
      leftOperand: configurationService.getHostCarrier()
    };
    return [new SearchCriteriaRule(ruleParams)];
  }
  dataRetrieverService.getDataRetriever(dataRetrieverConstantsService.SYSTEM_STATUS_SCREEN, dataRetrieverConstantsService.SYSTEM_REOPTIMIZATION_STATUS_MODE).setCustomSearchCriteriaRules(getSearchCriteria());
  $scope.reoptimize = function (event, rows) {
    reoptimizationService.reoptimizeFromStatusScreen(rows).then(function () {
      $scope.$broadcast('grid:dataChanged');
    });
  };
  $scope.cancelOptimization = function (event, rows) {
    for (var i = 0; i < rows.length; i++) {
      restangular.one('status').all('processingDays').remove({
        dateString: rows[i].localOptGroupDateString
      }).then(function (response) {
        if (response.n > 0) {
          toastr.success('Optimization canceled successfully');
        } else {
          toastr.warning('Cannot cancel optimization');
        }
      });
    }
    $scope.$broadcast('grid:dataChanged');
  };
  $scope.customRenderers = systemStatusCommonRendererFactory;
};
SystemStatusReoptimizationController.$inject = ['$scope', 'Restangular', 'DataRetrieverService', 'DataRetrieverConstantsService', 'ReoptimizationService', 'SystemStatusCommonRendererFactory', 'SearchCriteriaRuleFactory', 'ConfigurationService'];
module.exports = SystemStatusReoptimizationController;